import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

const translations = {
  'en-US': {
    'header.todayOpen': 'Open today',
    'header.todayClosed': 'Closed today',
    'header.title-logo-1': 'Shopping Center',
    'header.title-logo-2': 'Tapiola',
    'email-address': 'E-mail address',
    'thanks-ordering': 'Thank you for your order',
    'see-more': 'See more',
    'lunch.lunch-today': 'Lunch today',
    'lunch.today-lunch': 'Today lunch',
    'lunch.week-lunch': 'Week lunch',
    'lunch.lunch-time': 'Lunch time',
    'lunch.downloadMenu': 'Download menu',
    'lunch.week': 'Week',
    'offers.valid': 'Valid',
    'stores.know-the-store': 'Get to know the new store',
    'stores.opening-h': 'Opening hours',
    'stores.location': 'Location',
    'stores.open': 'Open',
    'stores.closed': 'Closed',
    'stores.available.stores1': 'Found',
    'stores.available.stores2': 'stores available',
    'stores.available.restaurants2': 'restaurants available',
    'stores.enterCategory': 'What are you looking for?',
    'stores.showFromAllStores': 'Show from all stores',
    'stores.allStores': 'All stores',
    'stores.allRestaurants': 'All restaurants',
    'stores.excitingOffers': 'This will surely get you excited',
    'stores.searchByName': 'Search by name',
    'search.noResults': 'No result',
    'stores.whereAreWe': 'Where are we',
    'stores.seeLocationOnMap': 'See location on the map',
    'stores.contact': 'Contact',
    'news.seeMore': 'Show all',
    'opening-hours.standard-opening-hours': 'Standard hours',
    'opening-hours.sc-shared-areas': 'Shopping centre shared areas',
    'opening-hours.sc-exceptional-opening-hours': 'Shopping centre exceptional opening hours',
    'opening-hours.stores_open_at_minimum': 'Stores open at minimum',
    'opening-hours.store-specific-standard-opening-hours': 'Store-specific standard opening hours',
    'opening-hours.store-specific-opening-hours': 'Store-specific opening hours',
    'opening-hours.some-stores-open': 'Some of the stores are open',
    'feedback.required_fields_marked_by_star': 'Required fields',
    'feedback.target': 'Target',
    'feedback.choose_shop' : 'Choose a shop',
    'feedback.type_of_feedback' : 'Type of feedback',
    'feedback.message': 'Feedback',
    'feedback.name' : 'Name',
    'feedback.email' : 'Email',
    'feedback.target.general': 'General feedback',
    'feedback.target.store': 'Feedback to a specific company',
    'feedback.type.thanks': 'Thanks',
    'feedback.type.suggestion': 'Suggestion',
    'feedback.type.complaint': 'Complaint',
    'feedback.type.other': 'Other',
    'feedback.rsvp' : 'I would like to receive a reply',
    'feedback.privacy_statement' : 'Privacy policy',
    'feedback.thank_you' : 'Thank you for your feedback',
    'feedback.send': 'Send',
    'feedback.error.check_all_required_fields': 'Please check all required fields are filled',
    'feedback.error.field_required' : 'Field is required',
    'feedback.error.invalid_email_address' : 'Invalid email address',
    'feedback.error.please_choose_a_store' : 'Please choose a store',
  },
  'fi-FI': {
    'header.todayOpen': 'Tänään avoinna klo',
    'header.todayClosed': 'Suljettu tänään',
    'header.title-logo-1': 'Kauppakeskus',
    'header.title-logo-2': 'Tapiola',
    'email-address': 'Sähköpostiosoitteesi',
    'thanks-ordering': 'Kiitos tilauksestasi',
    'see-more': 'Katso lisää',
    'lunch.lunch-today': 'Lounaalla tänään',
    'lunch.today-lunch': 'Lounas tänään',
    'lunch.week-lunch': 'Viikon lounas',
    'lunch.lunch-time': 'Lounasaika',
    'lunch.downloadMenu': 'Lataa ruokalista',
    'lunch.week': 'Viikko',
    'offers.valid': 'Voimassa',
    'stores.know-the-store': 'Tutustu uuteen liikkeeseen',
    'stores.opening-h': 'Aukiolot',
    'stores.location': 'Sijainti',
    'stores.open': 'Avoinna',
    'stores.closed': 'Suljettu',
    'stores.available.stores1': 'Tarjolla',
    'stores.available.stores2': 'liikettä',
    'stores.available.restaurants2': 'ravintolaa',
    'stores.enterCategory': 'Millaista haet?',
    'stores.showFromAllStores': 'Näytä kaikista liikkeistä',
    'stores.allStores': 'Kaikki liikkeet',
    'stores.allRestaurants': 'Kaikki ravintolat',
    'stores.excitingOffers': 'Tästä innostut takuulla',
    'stores.searchByName': 'Hae nimellä',
    'search.noResults': 'Ei tuloksia',
    'stores.whereAreWe': 'Missä olemme',
    'stores.seeLocationOnMap': 'Katso sijainti kartalla',
    'stores.contact': 'Yhteys',
    'news.seeMore': 'Näytä kaikki',
    'opening-hours.standard-opening-hours': 'Vakioaukioloajat',
    'opening-hours.sc-shared-areas': 'Kauppakeskuksen yleiset tilat avoinna',
    'opening-hours.sc-exceptional-opening-hours': 'Kauppakeskuksen poikkeukselliset aukioloajat',
    'opening-hours.stores_open_at_minimum': 'Liikkeet avoinna vähintään',
    'opening-hours.store-specific-standard-opening-hours': 'Liikkeiden ja ravintoloiden vakioaukioloajat',
    'opening-hours.store-specific-opening-hours': 'Liikekohtaiset aukioloajat',
    'opening-hours.some-stores-open': 'Osa liikkeistä palvelee',
    'feedback.required_fields_marked_by_star': 'Pakolliset tiedot on merkitty tähdellä',
    'feedback.target': 'Kohde',
    'feedback.choose_shop' : 'Valitse liike',
    'feedback.type_of_feedback' : 'Palautteen tyyppi',
    'feedback.message': 'Palaute',
    'feedback.name' : 'Nimesi',
    'feedback.email' : 'Sähköpostiosoitteesi',
    'feedback.target.general': 'Haluan antaa yleistä palautetta',
    'feedback.target.store': 'Haluan antaa palautetta tietylle toimijalle',
    'feedback.type.thanks': 'Kiitos',
    'feedback.type.suggestion': 'Ehdotus',
    'feedback.type.complaint': 'Moite',
    'feedback.type.other': 'Muu',
    'feedback.rsvp' : 'Haluan, että minulle vastataan',
    'feedback.privacy_statement' : 'Rekisteriseloste',
    'feedback.thank_you' : 'Kiitos palautteesta!',
    'feedback.send': 'Lähetä',
    'feedback.error.check_all_required_fields': 'Tarkista, että kaikki pakolliset kentät on täytetty.',
    'feedback.error.field_required' : 'Kenttä on pakollinen',
    'feedback.error.invalid_email_address' : 'Osoite on virheellinen',
  },
} as Localizations;

const provider: LocalizationsProvider = {
  namespace: theme_ns,
  localizations: translations,
};

export default provider;
